// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import { useContext } from "react";

import { ThemeContext } from "./ThemeContext";

export const useTheme = () => useContext(ThemeContext);
